import { Injectable } from '@angular/core';
import { UserSettingAdminViewModel } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserSettingAdminService {
    constructor(private http: HttpClient) {}

    public get(userId: string): Observable<UserSettingAdminViewModel> {
        return this.http.get<UserSettingAdminViewModel>(`api/usersettings/${userId}`);
    }

    public save(userSettingAdminViewModel: UserSettingAdminViewModel, userId: string): Observable<void> {
        return this.http.post<void>(`api/usersettings/${userId}`, userSettingAdminViewModel);
    }
}